import { NewMatterAccountControlDetails } from '@repo/ui/NewMatterAccountControlDetails'
import { NewMatterControlMatterAccess } from '@repo/ui/NewMatterControlMatterAccess'
import { NewMatterDetails } from '@repo/ui/NewMatterDetails'
import { NewMatterExtensions } from '@repo/ui/NewMatterExtensions'
import { NewMatterFeeEarner } from '@repo/ui/NewMatterFeeEarner'
import { NewMatterFunding } from '@repo/ui/NewMatterFunding'
import { NewMatterReview } from '@repo/ui/NewMatterReview'
import { NewMatterSummary } from '@repo/ui/NewMatterSummary'
import { useNewMatterStore } from '@repo/store/useNewMatterStore'

export default [
  {
    stageLabel: 'Create new matter',
    stageId: 'matter',
    resetData: useNewMatterStore.getState().reset,
    steps: [
      {
        stepLabel: 'Matter details',
        stepDescription: 'Please enter the matter details',
        stepId: 'matter-details',
        skippable: false,
        component: NewMatterDetails,
        uniqueId: 'new-matter-details'
      },
      {
        stepLabel: 'Matter extensions',
        stepDescription: 'Please enter additional details for the matter',
        stepId: 'matter-extensions',
        skippable: true,
        component: NewMatterExtensions,
        uniqueId: 'new-matter-extensions'
      },
      {
        stepLabel: 'Fee earner',
        stepDescription: 'Select fee earner and supervising fee earner',
        stepId: 'fee-earner',
        skippable: false,
        component: NewMatterFeeEarner,
        uniqueId: 'new-matter-feearner'
      },
      {
        stepLabel: 'Funding',
        stepDescription: 'Select the remuneration type for the matter',
        stepId: 'funding',
        skippable: true,
        component: NewMatterFunding,
        uniqueId: 'new-matter-funding'
      },
      {
        stepLabel: 'Account control details',
        stepDescription: 'Set debt limits against the matter',
        stepId: 'account-control-details',
        skippable: true,
        component: NewMatterAccountControlDetails,
        uniqueId: 'new-matter-account-control-details'
      },
      {
        stepLabel: 'Review',
        stepDescription: 'Set matter review dates',
        stepId: 'review',
        skippable: true,
        component: NewMatterReview,
        uniqueId: 'new-matter-review'
      },
      {
        stepLabel: 'Control matter access',
        stepDescription: 'Select which groups and users can access to the matter',
        stepId: 'control-matter-access',
        skippable: true,
        component: NewMatterControlMatterAccess,
        uniqueId: 'new-matter-control-access'
      },
      {
        stepLabel: 'Summary',
        stepDescription: 'New matter added',
        stepId: 'summary',
        skippable: false,
        component: NewMatterSummary,
        uniqueId: 'new-matter-summary'
      }
    ]
  }
]
